import { forEach } from "jszip";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Request } from "../../code/library-ts/node/web/Request";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";

export class PageInfoData
{
  id:string;
  data:string;
  page:string;
  time:string;
  type:string;
} 

export class PageInfoDataEntry
{
  id:string;
  data:PageInfoData;
}

export class DayData
{
  objects:PageInfoDataEntry[];
}

export class ShowData
{
  static readonly type = new ElementType( "show-data" );

  static applyOnDocument()
  {
    ShowData.type.forAllInDoc( e => ShowData.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let button = ElementType.button.queryDoc();

    OnClick.add( button,
      async ( ev )=>
      {

        let phpPath = "../_php/data/list.php?"; 
        let vars = [ "year", "month", "date", "password" ];

        let first = true;
        vars.forEach(
          ( v )=>
          { 
            if ( first ){ first = false; }
            else { phpPath += "&"; }
            phpPath += v + "=" + this.getInput( v );
          }
        );

        let result = await Request.getJSON<DayData>( phpPath );

        this.processData( result );

        console.log( result );
      }
    );
  }

  static processData( data:DayData )
  {
    let map = new Map<string,PageInfoData[]>();

    data.objects.forEach(
      ( ent )=>
      {
        
        if ( ! map.has( ent.data.id ) )
        {
          map.set( ent.data.id, [] );
        }

        let list = map.get( ent.data.id );
        list.push( ent.data );
      }
    );

    let output = ShowData.type.queryDoc();
    output.innerHTML = "";

    let allStats = ElementType.div.create();

    output.appendChild( allStats ); 

    let numRecords = 0;
    let humanRecords = 0;
    let botRecords = 0;
    let humanPages = 0;
    let humanDocPages = 0;
    let botPages = 0;
    let docPages = 0;

    let pagesMapping = new Map<string,number>();

    for ( let kv of map )
    {
      let list = kv[ 1 ];

      let container = ElementType.div.create(); 
      new ElementAttribute( "type" ).to( container, list[ 0 ].type );
      numRecords ++;

      let isHuman = list[ 0 ].type == "Human";

      if ( isHuman )
      {
        humanRecords ++;
      }
      else
      {
        botRecords ++;
      }

      output.appendChild( container );

      let id = ElementType.div.create( list[ 0 ].id );
      new ClassFlag( "id" ).set( id );
      container.appendChild( id );

      list.forEach(
        ( pd )=>
        {
          let page = ElementType.div.create( pd.page );
          
          if ( ! pagesMapping.has( pd.page ) )
          { 
            pagesMapping.set( pd.page, 0 )
          }

          pagesMapping.set( pd.page, pagesMapping.get( pd.page ) + 1 );

          new ClassFlag( "page" ).set( page );
          container.appendChild( page );

          if ( isHuman )
          {
            humanPages ++;
          }
          else
          {
            botPages ++;
          }

          if ( pd.page.startsWith( "en/labs/godot/docs/" ) )
          {
            docPages ++;

            if ( isHuman )
            {
              humanDocPages ++;
            }
          }
        }
      )
    }

    let recordsData = "Records: " + numRecords +
                      " | Human Records: " + humanRecords + 
                      " | Bot Records: " + botRecords +
                      " | Pages: " + ( humanPages + botPages ) +
                      " | Doc Pages: " + docPages +
                      " | Human Pages: " + humanPages +
                      " | Human Doc Pages: " + humanDocPages +
                      " | Bot Pages: " + botPages;
    
    let recordsLabel = ElementType.div.create( recordsData );
    allStats.appendChild( recordsLabel );

    let pageStats:{name:string, count:number}[] = []; 

    for ( let kv of pagesMapping )
    {
      let name = kv[ 0 ];
      let count = kv[ 1 ];

      pageStats.push( { name, count })

      
    }

    pageStats.sort(
      ( a, b )=>
      {
        return b.count - a.count;
      }
    )

    pageStats.forEach(
      ( ps )=>
      {
        allStats.appendChild( ElementType.div.create( "Page: " + ps.name + " ( " + ps.count + " ) " ) );
      }
    )
  }

  static getInput( classString:string )
  {
    let flag = new ClassFlag( classString );
    let element = flag.queryDoc();

    if ( ! element )
    {
      console.log( "Not found:", classString );
    }

    return ( element as HTMLInputElement ).value;
  }
}